import '@/App.css'
import ItemListView from '@/views/ItemListView'
import { createContext, useState } from 'react'
import { SelectedItem } from './types/Types'
import { useSelectedItem } from './customHooks/useSelectedItem'
import Ad from './views/Ad'

export const SelectedItemContext = createContext({} as SelectedItem)

const App = () => {
  // #region フック

  const selectedItem = useSelectedItem()

  const [is234] = useState(() => Math.random() < 0.5)

  // #endregion フック

  // #region スタイル

  const adAreaStyle: React.CSSProperties = {
    textAlign: 'center'
  }

  const adHeadlineStyle: React.CSSProperties = {
    margin: '8px 0 0 0',
    fontSize: '20px',
    fontFamily: 'Meiryo',
    fontWeight: 'bold'
  }

  const adMainStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center'
  }

  const hrStyle: React.CSSProperties = {
    marginLeft: '18px'
  }

  const spaceStyle: React.CSSProperties = {
    marginLeft: '10px'
  }

  const displayStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column'
  }

  const itemListStyle: React.CSSProperties = {
    //height: '400px'
  }

  // #endregion スタイル

  // #region イベント

  // #endregion イベント

  return (
    <SelectedItemContext.Provider value={selectedItem}>
      <div style={adAreaStyle}>
        <p style={adHeadlineStyle}>広告</p>
        {is234 ? (
          <div style={adMainStyle}>
            <Ad width={234} height={60} />
            <Ad width={234} height={60} />
            <Ad width={234} height={60} />
          </div>
        ) : (
          <div style={adMainStyle}>
            <Ad width={468} height={60} />
            <Ad width={468} height={60} />
          </div>
        )}
      </div>
      <hr style={hrStyle} />
      <div style={spaceStyle}>
        <h1>ドラゴンクエスト9 お買い物リスト（総費用計算ツール）</h1>
        <div style={spaceStyle}>
          欲しいアイテム（売品）とその個数を指定してリストに追加します。
          <br />
          リストにあるアイテムを全て購入するのに必要な金額を計算します。
          <hr />
          <div style={displayStyle}>
            <div style={itemListStyle}>
              <ItemListView />
            </div>
          </div>
          <hr />
          <a href='/tools'>ツール置き場に戻る</a>
          {'　|　'}
          <a href='/'>トップページに戻る</a>
          {'　|　'}
          <a href='/blog/hello-world'>運営者情報</a>
          {'　|　'}
          <a href='/blog/privacypolicy'>プライバシーポリシー</a>
        </div>
      </div>
    </SelectedItemContext.Provider>
  )
}

export default App
